
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const mm = this.$gsap.matchMedia()

      mm.add(
        '(min-width: 1024px)',
        () => {
          const q = this.$gsap.utils.selector(this.$el)

          this.$gsap.set(q('.path1'), {
            transformOrigin: '70% 22%',
            rotate: '36deg',
            opacity: 0,
          })
          this.$gsap.set(q('.path2'), {
            transformOrigin: '65% 46%',
            rotate: '62deg',
            opacity: 0,
          })
          this.$gsap.set(q('.path3'), {
            transformOrigin: '65% 43%',
            rotate: '92deg',
            opacity: 0,
          })
          this.$gsap.set(q('.path4'), {
            transformOrigin: '87% 50%',
            rotate: '19deg',
          })

          const tl = this.$gsap
            .timeline({
              // paused: true,
              scrollTrigger: {
                trigger: this.$refs.container,
                start: 'top+=10% bottom',
                end: 'bottom center',
                toggleActions: 'play none none reverse',
                onEnter() {
                  tl.restart()
                },
                onLeaveBack() {
                  tl.reverse()
                },
                // scrub: 0.5,
                // markers: true,
              },
            })

            .from(
              q('#wobble3'),
              {
                opacity: 0,
                xPercent: 100,
                yPercent: 0,
                ease: 'power2.out',
                duration: 0.7,
              },
              0
            )
            .to(
              [q('.path4')],
              {
                rotate: '0deg',
                duration: 0.5,
                ease: 'ease.inOut',
              },
              '<+=.1'
            )
            .set(
              [q('.path1'), q('.path2'), q('.path3')],
              {
                opacity: 1,
              },
              '>-=.16'
            )
            .to(
              [q('.path1')],
              {
                rotate: '0deg',
                duration: 0.6,
                ease: 'ease.inOut',
              },
              '<'
            )
            .to(
              [q('.path2')],
              {
                rotate: '0deg',
                duration: 0.6,
                ease: 'ease.inOut',
              },
              '<'
            )
            .to(
              [q('.path3')],
              {
                rotate: '0deg',
                duration: 0.6,
                ease: 'ease.inOut',
              },
              '<'
            )
        },
        this.$refs.container
      )
    },
  },
}
